module.exports = __webpack_public_path__ + "img/slika47.6d60ea84.jpg";